import React from "react";
import {
	Router,
	Switch,
	Route,
	Redirect
} from "react-router-dom";
import { createBrowserHistory } from "history";
import { Toaster } from 'react-hot-toast';

import './App.scss';

import ComingSoon from './home/Main/ComingSoon';
import PrivacyPolicy from './home/PrivacyPolicy';
import Terms from './home/Terms';
import DeleteAccount from './home/DeleteAccount';
import DeleteData from './home/DeleteData';
import Support from './home/Support';
import { RegisterRoutes } from './auth/AuthRoutes';
import AdminRoute from './admin/AdminRoute';
import AdminLayout from './admin/AdminLayout';
import { reducer, initialState } from "./store/store";
import { applyMiddleware } from "./store/middleware";
import Helper from "./utils/Helper";
import AxiosConfig from './AxiosConfig';
import IdleTimer from "./utils/IdleTimer";
import InModal from "./components/Modal/Modal"

export let outsideDispatch;
export const AppContext = React.createContext();

export const history = createBrowserHistory()

function App() {

	const [state, dispatch] = React.useReducer(reducer, initialState);

	const enhancedDispatch = applyMiddleware(dispatch);
  	outsideDispatch = enhancedDispatch;

	React.useEffect(() => {
		AxiosConfig.init();
	}, [])
	React.useEffect(() => {

		if (state.auth.token) {

			enhancedDispatch({
				type: "GET_USER_REQUEST",
				payload: {},
			})

			if (Helper.getSubdomain() !== '') {
				enhancedDispatch({
					type: "GET_REGISTRATION_FIELDS_REQUEST",
					payload: Helper.getSubdomain(),
				})
			}

			// Auto Logout
			const timer = new IdleTimer({
				timeout: 60 * 60 * 12, //expire after 12 hours
				onTimeout: () => {
					// logout
					enhancedDispatch({
						type: "LOGOUT_REQUEST",
						payload: {},
					});
				},
				onExpired: () => {
					//do something if expired on load
				}
			});

			return () => {
				timer.cleanUp();
			};
		}
	}, [state.auth.token])

	return (
		<AppContext.Provider
			value={{
				state,
				dispatch: enhancedDispatch,
			}}
		>
			<Toaster />
			<InModal />
			<Router history={history}>
				<Switch>
					<Route path="/heartbeat">
					    <h3>lub dub</h3>
					</Route>
					<Route path="/login-sign-up">
						<RegisterRoutes />
					</Route>
					<AdminRoute path="/admin" component={AdminLayout} />
					<Route path="/privacy">
						<PrivacyPolicy />
					</Route>
					<Route path="/terms">
						<Terms />
					</Route>
					<Route path="/delete_account">
						<DeleteAccount />
					</Route>
					<Route path="/delete_data">
						<DeleteData />
					</Route>
					<Route path="/support">
						<Support />
					</Route>
					<Route path="/" exact>
						<ComingSoon />
					</Route>
					<Route path="*">
						<Redirect to="/" />
					</Route>
				</Switch>
			</Router>
		</AppContext.Provider>
	);
}

export default App;
